export default function BrandLogo({ variant = "sidebar" }) {
  return (
    <div className={`brand-logo brand-logo--${variant}`}>
      <img
        src={`${process.env.PUBLIC_URL}/percasa-logo.png`}
        alt="PERCASA logo"
        className="brand-logo-img"
      />
      <div className="brand-logo-text">
        <div className="brand-logo-title">PERCASA</div>
        <div className="brand-logo-sub">Residence Management</div>
      </div>
    </div>
  );
}
